import { Grid, Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { withAuth } from 'util/withAuth';
import theme from 'theme/theme';

const useStyles = makeStyles(() => ({
  container: {
    padding: '90px 0 25px',
    backgroundColor: theme.palette.orange,
    textAlign: 'center',
  },
  titleTextGroup: {
    marginBottom: '30px',
  },
  titleText: {
    marginBottom: '20px',
  },
  text: {
    marginBottom: '25px',
  },
  leftAlign: {
    textAlign: 'left',
    margin: '30px 0',
  },
  button: {
    color: theme.palette.orange,
    backgroundColor: theme.palette.black,
    '&:hover': {
      color: theme.palette.black,
      backgroundColor: theme.palette.orange,
      transition: '0.3s linear',
    },
  },
  submitButton: {
    display: 'block',
    width: '100%',
    margin: '30px auto 40px',
    textTransform: 'none',
    [theme.breakpoints.up('md')]: {
      width: '40%',
    },
  },
}));

const Terms = () => {
  const classes = useStyles();
  return (
    <Grid
      container
      className={classes.container}
      direction="row"
      justify="center"
      alignItems="center"
    >
      <Grid
        item
        xs={10}
        md={8}
        justify="center"
        className={classes.titleTextGroup}
      >
        <Typography variant="h1" className={classes.titleText}>
          Terms of Use
        </Typography>
        <Typography variant="h5" justify="center" className={classes.text}>
          Welcome to the Save Your City Website
        </Typography>
        <Typography
          variant="body1"
          justify="left"
          className={clsx(classes.text, classes.leftAlign)}
        >
          Welcome to the Save Your City, Inc. (“SYC”, “Us”, “Our” or “We”)
          Website and thank You for visiting.
          <br />
          <br />
          We hope You enjoy the experience!
          <br />
          <br />
          These Terms of Use (“Terms”) are a legal contract between You and Us
          (collectively, “Everyone”) and govern Your use of the website
          accessible at{' '}
          <Link color="inherit" underline="always" href="/">
            https://www.saveyourcity.nyc
          </Link>{' '}
          (the “Website”) and any services (“Services”) We may provide through
          the Website.
          <br />
          <br />
          READ THESE TERMS CAREFULLY BEFORE BROWSING THIS WEBSITE. USING THIS
          WEBSITE INDICATES THAT YOU HAVE BOTH READ AND ACCEPT THESE TERMS. YOU
          CANNOT USE THIS WEBSITE IF YOU DO NOT ACCEPT THESE TERMS.
          <br />
          <br />
          NOTE: THESE TERMS CONTAIN A DISPUTE RESOLUTION AND ARBITRATION
          PROVISION, INCLUDING CLASS ACTION WAIVER THAT AFFECTS YOUR RIGHTS
          UNDER THESE TERMS AND WITH RESPECT TO DISPUTES YOU MAY HAVE WITH THE
          COMPANY. YOU MAY OPT OUT OF THE BINDING INDIVIDUAL ARBITRATION AND
          CLASS ACTION WAIVER AS PROVIDED BELOW.
          <br />
          <br />
          <b>SAVE YOUR CITY.</b>
          <br />
          <br />
          SYC is an online community that provides a direct funding mechanism
          for individuals or entities (“Donors”) to donate funds to support
          local businesses in New York city (“Businesses”).
          <br />
          <br />
          <b>CHANGES.</b>
          <br />
          <br />
          We may alter the Website and Services We offer You and/or choose to
          modify, suspend or discontinue this Website at any time and without
          notifying You. We may also change, update, add or remove provisions
          (collectively, “modifications”) of these Terms from time to time.
          Because Everyone benefits from clarity, We promise to inform You of
          any modifications to these Terms by posting them on this Website.
          <br />
          <br />
          If You object to any such modifications, Your sole recourse shall be
          to cease using this Website. Continued use of this Website following
          notice of any such modifications indicates You acknowledge and agree
          to be bound by the modifications. Also, please know that these Terms
          may be superseded by expressly-designated legal notices or terms
          located on particular pages of this Website. These
          expressly-designated legal notices or terms are incorporated into
          these Terms and supersede the provision(s) of these Terms that are
          designated as being superseded.
          <br />
          <br />
          <b>GENERAL USE.</b>
          <br />
          <br />
          We invite You to use this Website for individual, consumer purposes
          (“Permitted Purposes”) – enjoy!
          <br />
          <br />
          By using the Website, You agree that you are at least 18 years of age,
          or if you are under 18 years of age (a “Minor”), that you are using
          the Website with the consent of your parent or legal guardian and You
          have received your parent’s or legal guardian’s permission to use the
          Website and agree to these Terms. If You are a parent or legal
          guardian of a Minor, you agree to bind the Minor to these Terms and to
          fully indemnify and hold Us harmless if the Minor breaches any of
          these Terms.
          <br />
          <br />
          In these Terms We are granting You a limited, personal, non-exclusive
          and non-transferable license to access and use the Website and the
          Services; Your right to use the Website and the Services is
          conditioned on Your compliance with these Terms. You have no other
          rights in this Website or any Services and You may not modify, edit,
          copy, reproduce, create derivative works of, reverse engineer, alter,
          enhance or in any way exploit any of this Website in any manner. If
          You make copies of any of this Website while engaging in Permitted
          Purposes then We ask that You be sure to keep on the copies all of Our
          copyright and other proprietary notices as they appear on this
          Website.
          <br />
          <br />
          Unfortunately, if You breach any of these Terms the above license will
          terminate automatically and You must immediately cease any use of the
          Website and the Services.
          <br />
          <br />
          <b>USING THIS WEBSITE AND THE WEBSITE’S SERVICES.</b>
          <br />
          <br />
          We appreciate You visiting this Website and allow You to do just that
          – stop by and leisurely check it out!
          <br />
          <br />
          <u>Businesses</u>: A Business may receive donations from Donors who
          specifically donate to the Business through the Website. In order to
          be eligible to receive the donation, the Business must be verified by
          SYC and hold an active account under Stripe.com to receive the
          donation. If the Business cannot be verified because it does not
          timely respond to any inquiries from SYC, then the Business may not be
          eligible to receive the donation. Businesses may also nominate
          themselves on the Website in order to be added to SYC database. SYC
          does not guarantee that a nominated Business will obtain a certain
          amount of donations or any donations at all. The Website and Services
          are run by volunteers. We will do our best to verify and add nominated
          businesses to the site in a timely manner but it may take 5 or more
          business days depending on the volume of nominations and time it takes
          to obtain necessary documentation.
          <br />
          <br />
          <u>Donors</u>: A Donor may donate funds to any Business of its choice,
          provided the Business is eligible to receive the donation as set forth
          hereunder. In order to donate to a Business, a Donor will be required
          to designate the Business to receive the donation and provide SYC with
          information regarding the Donor’s credit card or other payment method
          through the Website. Once the Donor has made a contribution to a
          Business, SYC will contact the Business to verify the existence of the
          Business, and locate the Stripe account for the Business. Once the
          foregoing is completed, SYC will process payment to the Business
          through its Stripe account. If the Business cannot be verified or the
          Business does not accept the contribution, then Donor’s contribution
          will be passed to Partnership to New York City, a nonprofit membership
          organization. By providing a payment method for donation, Donor
          expressly authorizes SYC and/or Our third party payment processor to
          charge the applicable fees on said payment method. Donor represents
          and warrants that such information is true and that the Donor is
          authorized to use the applicable payment method. All donation payments
          are final and will not be refunded.
          <br />
          <br />
          We do not endorse any Business, and make no guarantee, express or
          implied, that any information provided through the Website is
          accurate. We expressly disclaim any liability or responsibility for
          the outcome or success of any Business. You as the Donor must make the
          final determination as to the value and appropriateness of any
          donation or contribution to any Business.
          <br />
          <br />
          <u>Volunteer</u>: Individuals may register as volunteers
          (“Volunteers”) to perform part or all of the Services on behalf of SYC
          by executing a volunteer agreement available at{' '}
          <Link color="inherit" underline="always" href="https://cvd.cm/syc">
            https://cvd.cm/syc
          </Link>{' '}
          and meeting eligibility requirements at Our sole discretion. By
          registering as a Volunteer, You as the Volunteer represent and warrant
          that: (a) all registration information the Volunteer submits is
          truthful and accurate; (b) Volunteer will maintain the accuracy of
          such information; (c) Volunteer’s performance of the Services does not
          violate any applicable law or regulation; and (d) Volunteer will
          comply with all the terms of the volunteer agreement. Volunteer’s
          registration profile may be deleted or suspended without warning if We
          have reason to believe that the Volunteer does not meet eligibility
          requirements.
          <br />
          <br />
          <b>PAYMENT.</b>
          <br />
          <br />
          We are not a payment processor and do not hold any funds. Instead, We
          use third-party payment processing partners to process donations for a
          Business (“Payment Processor”). Donors acknowledge and agree that the
          use of Payment Processors is integral to the Services and that We
          exchange information with Payment Processors in order to facilitate
          the provision of Services.
          <br />
          <br />
          The Website is administrative platforms only. We permit the Donors to
          make donations to the Businesses and facilitate the receipt of the
          donation by the Businesses. We are not a broker, agent, financial
          institution, creditor, charity or 501(c)(3) nonprofit corporation. No
          content is intended to provide financial, legal, tax or other
          professional advice.
          <br />
          <br />
          We merely provide the Website and the Services to allow Donors to
          contribute funds to the Businesses. The existence of the Website or
          the Services is not a solicitation of donations by Us, and We do not
          engage in any solicitation activities, or consult on the solicitation
          of contributions from the public, on behalf of any individual, entity,
          or organization. By using the Website or the Services, Donors
          understand and agree that We shall not be responsible for the use of
          the donations or the amount of contributions for the Businesses.
          <br />
          <br />
          We make no representation as to whether all or any portion of the
          donations, including, if any, transaction fees, are tax deductible or
          eligible for tax credits. We will have no liability for any claim by
          any federal, state, provincial, territorial, local or any other tax
          authority with respect to the characterization on any applicable tax
          return of any donation. Donors should consult their tax advisor as to
          the amount of the donation that is tax deductible or eligible for tax
          recognition, having regard to (among other things) the tax status of
          the recipient of any donation in any relevant jurisdiction.
          <br />
          <br />
          <b>PRIVACY POLICY.</b>
          <br />
          <br />
          We respect the information that You provide to Us, and want to be sure
          You fully understand exactly how We use that information. So, please
          review Our Privacy Policy (“Privacy Policy”) on Our site which
          explains everything.
          <br />
          <br />
          <b>ELECTRONIC COMMUNICATIONS.</b>
          <br />
          <br />
          By using this Website (or any part thereof) or the Services, You
          consent to receiving electronic communications from Us (including, if
          You have opted in, via text message). These electronic communications
          may include notices about applicable fees and charges, transactional
          information and other information concerning or related to this
          Website or the Services. These electronic communications are part of
          Your relationship with Us. You agree that any notices, agreements,
          disclosures or other communications that We send You electronically
          will satisfy any legal communication requirements, including that such
          communications be in writing. Standard carrier data charges may apply
          to Your use of text messaging and You are solely responsible for such
          charges.
          <br />
          <br />
          <b>LINKS TO THIRD-PARTY SITES.</b>
          <br />
          <br />
          We think links are convenient, and We sometimes provide links on this
          Website to third-party websites. If You use these links, You will
          leave this Website. We are not obligated to review any third-party
          websites that You link to from this Website, We do not control any of
          the third-party websites, and We are not responsible for any of the
          third-party websites (or the products, services, or content available
          through any of them). Thus, We do not endorse or make any
          representations about such third-party websites, any information,
          software, products, services, or materials found there or any results
          that may be obtained from using them. If You decide to access any of
          the third-party websites linked to from this Website, You do this
          entirely at Your own risk and You must follow the privacy policies and
          terms and conditions for those third-party websites. Certain areas of
          this Website may allow You to interact and/or conduct transactions
          with one or more third-party websites, and, if applicable, allow you
          to configure your privacy settings in that third-party website account
          to permit Your activities on this Website to be shared with Your
          contacts in your third-party site account.
          <br />
          <br />
          <b>USER SUBMISSIONS.</b>
          <br />
          <br />
          Certain areas of the Website may permit You to upload or submit
          feedback, information, images, data, text, software, messages, or
          other materials (each, a “User Submission”). You agree that You are
          solely responsible for all of Your User Submissions and that any such
          User Submission is considered both non-confidential and
          non-proprietary. Further, We do not guarantee that You will be able to
          edit or delete any User Submission You have submitted.
          <br />
          <br />
          By submitting any User Submission, You are promising Us that:
          <ul>
            <li>
              You own all rights in Your User Submissions (including, without
              limitation, all rights to the reproduction and display of Your
              User Submissions) or, alternatively, You have acquired all
              necessary rights in Your User Submissions to enable You to grant
              to Us the rights in Your User Submissions as described in these
              Terms;
            </li>
            <li>
              You have paid and will pay in full all license fees, clearance
              fees, and other financial obligations, of any kind, arising from
              any use or commercial exploitation of Your User Submissions;
            </li>
            <li>
              Your User Submissions do not infringe the copyright, trademark,
              patent, trade secret, or other intellectual property rights,
              privacy rights, or any other legal or moral rights of any third
              party;
            </li>
            <li>
              You voluntarily agree to waive all "moral rights" that You may
              have in Your User Submission;
            </li>
            <li>
              Any information contained in Your User Submission is not known by
              You to be false, inaccurate, or misleading;
            </li>
            <li>
              Your User Submission does not violate any law (including, but not
              limited to, those governing export control, consumer protection,
              unfair competition, anti-discrimination, or false advertising);
            </li>
            <li>
              Your User Submission is not, and may not reasonably be considered
              to be, defamatory, libelous, hateful, racially, ethnically,
              religiously, or otherwise biased or offensive, unlawfully
              threatening, or unlawfully harassing to any individual,
              partnership, or corporation, vulgar, pornographic, obscene, or
              invasive of another's privacy;
            </li>
            <li>
              You were not and will not be compensated or granted any
              consideration by any third party for submitting Your User
              Submission;
            </li>
            <li>
              Your User Submission does not incorporate materials from a
              third-party website, or addresses, email addresses, contact
              information, or phone numbers (other than Your own);
            </li>
            <li>
              Your User Submission does not contain any viruses, worms, spyware,
              adware, or other potentially damaging programs or files;
            </li>
            <li>
              Your User Submission does not contain any information that You
              consider confidential, proprietary, or personal; and
            </li>
            <li>
              Your User Submission does not contain or constitute any
              unsolicited or unauthorized advertising, promotional materials,
              junk mail, spam, chain letters, pyramid schemes, or any other form
              of solicitation.
            </li>
          </ul>
          By submitting a User Submission, You grant to Us an irrevocable,
          perpetual, transferable, non-exclusive, fully-paid, worldwide,
          royalty-free license (sublicensable through multiple tiers) to:
          <ul>
            <li>
              Use, distribute, reproduce, modify, adapt, publish, translate,
              publicly perform, and publicly display Your User Submissions (or
              any modification thereto), in whole or in part, in any format or
              medium now known or later developed;{' '}
            </li>
            <li>
              Use (and permit others to use) Your User Submission in any manner
              and for any purpose (including, without limitation, commercial
              purposes) that We deem appropriate in Our sole discretion
              (including, without limitation, to incorporate Your User
              Submission or any modification thereto, in whole or in part, into
              any technology, product, or service);
            </li>
            <li>
              Display advertisements in connection with Your User Submissions
              and to use Your User Submissions for advertising and promotional
              purposes.
            </li>
          </ul>
          We may, but are not obligated to, pre-screen User Submissions or
          monitor any area of the Website through which User Submissions may be
          submitted. We are not required to host, display, or distribute any
          User Submissions on the Website and may remove at any time or refuse
          any User Submissions for any reason. We are not responsible for any
          loss, theft, or damage of any kind to any User Submissions. Further,
          You agree that We may freely disclose Your User Submission to any
          third party absent any obligation of confidence on the part of the
          recipient.
          <br />
          <br />
          <b>UNAUTHORIZED ACTIVITIES.</b>
          <br />
          <br />
          To be clear, We authorize Your use of this Website only for Permitted
          Purposes. Any other use of this Website beyond the Permitted Purposes
          is prohibited and, therefore, constitutes unauthorized use of this
          Website. This is because as between You and Us, all rights in this
          Website remain Our property.
          <br />
          <br />
          Unauthorized use of this Website may result in violation of various
          United States and international copyright laws. Because We prefer
          keeping this relationship drama-free, We want to give You examples of
          things to avoid. So, unless You have written permission from Us
          stating otherwise, You are not authorized to use this Website in any
          of the following ways (these are examples only and the list below is
          not a complete list of everything that You are not permitted to do):
          <ul>
            <li>
              For any public or commercial purpose which includes use of this
              Website on another site or through a networked computer
              environment;
            </li>
            <li>
              In a manner that modifies, publicly displays, publicly performs,
              reproduces or distributes any of this Website;
            </li>
            <li>
              In a manner that violates any local, state, national, foreign, or
              international statute, regulation, rule, order, treaty, or other
              law;
            </li>
            <li>To stalk, harass, or harm another individual;</li>
            <li>
              To impersonate any person or entity or otherwise misrepresent Your
              affiliation with a person or entity;
            </li>
            <li>
              To interfere with or disrupt this Website or servers or networks
              connected to this Website;
            </li>
            <li>
              To use any data mining, robots, or similar data gathering or
              extraction methods in connection with this Website; or
            </li>
            <li>
              Attempt to gain unauthorized access to any portion of this Website
              or any other accounts, computer systems, or networks connected to
              this Website, whether through hacking, password mining, or any
              other means.
            </li>
          </ul>
          You agree to hire attorneys to defend Us if You violate these Terms
          and that violation results in a problem for Us. You also agree to pay
          any damages that We may end up having to pay as a result of Your
          violation. You alone are responsible for any violation of these Terms
          by You. We reserve the right to assume the exclusive defense and
          control of any matter otherwise subject to indemnification by You and,
          in such case, You agree to cooperate with Our defense of such claim.
          <br />
          <br />
          <b>PROPRIETARY RIGHTS.</b>
          <br />
          <br />
          The trademarks, service marks, and logos of SYC (“Our Trademarks”)
          used and displayed on various parts of the Website are registered and
          unregistered trademarks or service marks of SYC. Other company,
          product, and service names located on the Website may be trademarks or
          service marks owned by others (the “Third-Party Trademarks”, and,
          collectively with Our Trademarks, the “Trademarks”). Nothing in these
          Terms should be construed as granting, by implication, estoppel, or
          otherwise, any license or right to use the Trademarks, without Our
          prior written permission specific for each such use. Use of the
          Trademarks as part of a link to or from any site is prohibited unless
          establishment of such a link is approved in advance by Us in writing.
          All goodwill generated from the use of Our Trademarks inures to Our
          benefit.
          <br />
          <br />
          Unless otherwise specified in these Terms, the Website, including the
          contents and materials on this Website are Our sole property, or the
          property of Our licensors. All rights not expressly granted herein are
          reserved. Except as otherwise required or limited by applicable law,
          any reproduction, distribution, modification, retransmission, or
          publication of any copyrighted material is strictly prohibited without
          the express written consent of the copyright owner or license.
          <br />
          <br />
          <b>INTELLECTUAL PROPERTY INFRINGEMENT.</b>
          <br />
          <br />
          We respect the intellectual property rights of others and encourage
          You to do the same. Accordingly, We have a policy of removing User
          Submissions that violate intellectual property rights of others,
          suspending access to this Website (or any portion thereof) to any user
          who uses this Website in violation of someone’s intellectual property
          rights, and/or terminating in appropriate circumstances the account of
          any user who uses the this Website in violation of someone’s
          intellectual property rights.
          <br />
          <br />
          Pursuant to Title 17 of the United States Code, Section 512 (the
          “Digital Millennium Copyright Act” or “DMCA”), We have implemented
          procedures for receiving written notification of claimed copyright
          infringement and for processing such claims in accordance with such
          law. If You believe Your copyright or other intellectual property
          right is being infringed by a user of this Website, please provide
          written notice to Our agent (“Agent”) for notice of claims of
          infringement:
          <br />
          <br />
          Attn: Oliver Libby
          <br />
          CC: Melissa Capone
          <br />
          Email:{' '}
          <Link
            color="inherit"
            underline="always"
            href="mailto:support@saveyourcity.zendesk.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            support@saveyourcity.zendesk.com
          </Link>
          <br />
          <br />
          To be sure the matter is handled immediately, Your written notice
          must:
          <ul>
            <li>Contain Your physical or electronic signature;</li>
            <li>
              Identify the copyrighted work or other intellectual property
              alleged to have been infringed;
            </li>
            <li>
              Identify the allegedly infringing material in a sufficiently
              precise manner to allow Us to locate that material;
            </li>
            <li>
              Contain adequate information by which We can contact You
              (including postal address, telephone number, and e-mail address);
            </li>
            <li>
              Contain a statement that You have a good faith belief that use of
              the copyrighted material or other intellectual property is not
              authorized by the owner, the owner's agent or the law;
            </li>
            <li>
              Contain a statement that the information in the written notice is
              accurate; and
            </li>
            <li>
              Contain a statement, under penalty of perjury, that You are
              authorized to act on behalf of the copyright or other intellectual
              property right owner.
            </li>
          </ul>
          Unless the notice pertains to copyright or other intellectual property
          infringement, the Agent will be unable to address the listed concern.
          <br />
          <br />
          <u>Submitting a DMCA Counter-Notification</u>
          <br />
          <br />
          We will notify You that We have removed or disabled access to
          copyright-protected material that You provided, if such removal is
          pursuant to a validly received DMCA take-down notice. In response, You
          may provide Our Agent with a written counter-notification that
          includes the following information:
          <ol>
            <li>Your physical or electronic signature;</li>
            <li>
              Identification of the material that has been removed or to which
              access has been disabled, and the location at which the material
              appeared before it was removed or access to it was disabled;
            </li>
            <li>
              A statement from You under the penalty of perjury, that You have a
              good faith belief that the material was removed or disabled as a
              result of a mistake or misidentification of the material to be
              removed or disabled; and
            </li>
            <li>
              Your name, physical address and telephone number, and a statement
              that You consent to the jurisdiction of a court for the judicial
              district in which Your physical address is located, or if Your
              physical address is outside of the United States, for any judicial
              district in which We may be located, and that You will accept
              service of process from the person who provided notification of
              allegedly infringing material or an agent of such person.
            </li>
          </ol>
          <u>Termination of Repeat Infringers</u>
          <br />
          <br />
          We reserve the right, in Our sole discretion, to terminate the account
          or access of any user of this Website or Service who is the subject of
          repeated DMCA or other infringement notifications.
          <br />
          <br />
          <b>DISCLAIMER OF WARRANTIES.</b>
          <br />
          <br />
          THE WEBSITE, AND THE SERVICES ARE PROVIDED “AS IS” AND “WITH ALL
          FAULTS”, AND THE ENTIRE RISK AS TO THEIR USE IS WITH YOU. WE EXPRESSLY
          DISCLAIM ALL WARRANTIES OF ANY KIND (EXPRESS, IMPLIED OR STATUTORY)
          WITH RESPECT TO THE WEBSITE, AND THE SERVICES, WHICH INCLUDES BUT IS
          NOT LIMITED TO, ANY IMPLIED OR STATUTORY WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR USE OR PURPOSE, TITLE, AND
          NON-INFRINGEMENT OF INTELLECTUAL PROPERTY RIGHTS.
          <br />
          <br />
          WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, WE MAKE NO WARRANTY
          THAT THE WEBSITE, AND/OR SERVICES WILL MEET YOUR REQUIREMENTS, THAT
          YOUR USE OF THE WEBSITE WILL BE UNINTERRUPTED, TIMELY, SECURE, OR
          ERROR FREE OR THAT DEFECTS IN THE WEBSITE WILL BE CORRECTED. WE MAKE
          NO WARRANTY AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE
          WEBSITE, AND/OR SERVICES, OR AS TO THE ACCURACY OR RELIABILITY OF ANY
          INFORMATION OR SERVICES OBTAINED THROUGH THE USE OF THE WEBSITE, AND
          ARE NOT RESPONSIBLE FOR THE PRODUCTS, SERVICES, ACTIONS, OR FAILURE TO
          ACT OF ANY THIRD PARTY. NO ADVICE OR INFORMATION, WHETHER ORAL OR
          WRITTEN, OBTAINED BY YOU THROUGH THE WEBSITE OR FROM US OR OUR
          SUBSIDIARIES/OTHER AFFILIATED COMPANIES SHALL CREATE ANY WARRANTY. WE
          DISCLAIM ALL EQUITABLE INDEMNITIES.
          <br />
          <br />
          YOU ACCEPT FULL RESPONSIBILITY FOR ANY AND ALL DECISIONS OR
          TRANSACTIONS YOU MAKE IN THE COURSE OF USING THE WEBSITE. YOU
          ACKNOWLEDGE AND AGREE THAT (A) USE OF THE WEBSITE IS AT YOUR SOLE
          RISK; (B) SYC AND ITS THIRD PARTY SUPPLIERS SHALL NOT BE RESPONSIBLE
          FOR ANY INTERRUPTION IN USE OF THE WEBSITE, DELAYS OR ERRORS CAUSED BY
          ANY USER’S USE OF THE WEBSITE, OR ANY PART THEREOF; AND (C) SYC IS
          NEITHER ACTING IN A FIDUCIARY CAPACITY NOR PROVIDING ANY INVESTMENT
          ADVICE TO ANY USER.
          <br />
          <br />
          <b>LIMITATION OF LIABILITY.</b>
          <br />
          <br />
          YOU ARE USING THE WEBSITE, AND SERVICES AT YOUR SOLE RISK. WE SHALL
          NOT BE LIABLE TO YOU FOR ANY DAMAGES RESULTING FROM YOUR DISPLAYING,
          COPYING, OR DOWNLOADING ANY MATERIALS TO OR FROM THE WEBSITE OR YOUR
          USE OF OUR SERVICES. IN NO EVENT SHALL WE BE LIABLE TO YOU FOR ANY
          INDIRECT, EXTRAORDINARY, EXEMPLARY, PUNITIVE, SPECIAL, INCIDENTAL, OR
          CONSEQUENTIAL DAMAGES, OR FOR LOSS OF DATA, LOSS OF REVENUE, LOSS OF
          PROFITS, COST OF SUBSTITUTE GOODS AND SERVICES, LOSS OF USE, OR OTHER
          ECONOMIC ADVANTAGE, HOWEVER ARISING, EVEN IF WE KNOW THERE IS A
          POSSIBILITY OF SUCH DAMAGE. IN NO EVENT WILL OUR TOTAL LIABILITY UNDER
          THESE TERMS EXCEED $100.
          <br />
          <br />
          YOU ARE SOLELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND
          INTERACTIONS WITH OTHER USERS OF THE WEBSITE, AND WITH OTHER PERSONS
          WITH WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE THEREOF.
          WE MAKE NO REPRESENTATIONS OR WARRANTIES AS TO THE CONDUCT OF USERS OF
          THE WEBSITE OR THEIR COMPATIBILITY WITH ANY CURRENT OR FUTURE USERS OF
          THE WEBSITE. YOU AGREE TO TAKE REASONABLE PRECAUTIONS IN ALL
          COMMUNICATIONS AND INTERACTIONS WITH ANY PERSONS WITH WHOM YOU
          COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE WEBSITE,
          PARTICULARLY IF YOU MEET OFFLINE OR IN PERSON. WE EXPLICITLY DISCLAIM
          ALL LIABILITY FOR ANY ACT OR OMISSION OF ANY USER OF THE WEBSITE AND
          ALL OTHER THIRD PARTIES.
          <br />
          <br />
          <b>LOCAL LAWS; EXPORT CONTROL.</b>
          <br />
          <br />
          We control and operate this Website from Our headquarters in the
          United States of America and the entirety of this Website may not be
          appropriate or available for use in other locations. If You use this
          Website outside the United States of America, You are solely
          responsible for following applicable local laws.
          <br />
          <br />
          <b>DISPUTE RESOLUTION AND ARBITRATION; CLASS ACTION WAIVER.</b>
          <br />
          <br />
          <b>
            Please Read This Provision Carefully. It Affects Your Legal Rights.
          </b>
          <br />
          <br />
          This Provision facilitates the prompt and efficient resolution of any
          dispute (e.g., claim or controversy), whether based in contract,
          statute, regulation, ordinance, tort – including, but not limited to,
          fraud, misrepresentation, fraudulent inducement, or negligence – or
          any other legal or equitable theory, and includes the validity,
          enforceability or scope of this Provision (with the exception of the
          enforceability of the Class Action Waiver clause below) that may arise
          between You and Us (collectively, the “Disputes”). Effectively, then,
          “Dispute” is given the broadest meaning enforceable by law and
          includes any claims against other parties relating to services or
          products provided or billed to You (such as Our licensors, suppliers,
          dealers or third-party vendors) whenever You also assert claims
          against Us in the same proceeding.
          <br />
          <br />
          This Provision provides that all Disputes between You and Us shall be
          resolved by binding arbitration because acceptance of These Terms
          constitutes a waiver of Your right to litigation claims and all
          opportunity to be heard by a judge or jury. We prefer this because We
          believe arbitration is less drama-filled than litigation. To be clear,
          there is no judge or jury in arbitration, and court review of an
          arbitration award is limited. The arbitrator must follow these Terms
          and can award the same damages and relief as a court (including
          attorney’s fees). You may, however, opt-out of this Provision which
          means You would have a right or opportunity to bring claims in a
          court, before a judge or jury, and/or to participate in or be
          represented in a case filed in court by others (including, but not
          limited to, class actions). EVERYONE AGREES THAT, EXCEPT AS PROVIDED
          BELOW, ANY AND ALL DISPUTES, AS DEFINED ABOVE, WHETHER PRESENTLY IN
          EXISTENCE OR BASED ON ACTS OR OMISSIONS IN THE PAST OR IN THE FUTURE,
          WILL BE RESOLVED EXCLUSIVELY AND FINALLY BY BINDING ARBITRATION RATHER
          THAN IN COURT IN ACCORDANCE WITH THIS PROVISION.
          <br />
          <br />
          <u>Pre-Arbitration Claim Resolution</u>
          <br />
          <br />
          For all Disputes, whether pursued in court or arbitration, You must
          first give Us an opportunity to resolve the Dispute which is first
          done by emailing to Us at{' '}
          <Link
            color="inherit"
            underline="always"
            href="mailto:support@saveyourcity.zendesk.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            support@saveyourcity.zendesk.com
          </Link>{' '}
          the following information: (1) Your name, (2) Your address, (3) A
          written description of Your Claim, and (4) A description of the
          specific relief You seek. If We do not resolve the Dispute within 45
          days after receiving Your notification, then You may pursue Your
          Dispute in arbitration. You may pursue Your Dispute in a court only
          under the circumstances described below.
          <br />
          <br />
          <u>Exclusions from Arbitration/Right to Opt Out</u>
          <br />
          <br />
          Notwithstanding the above, Your or We may choose to pursue a Dispute
          in court and not by arbitration if: (a) the Dispute qualifies for
          initiation in small claims court; or (b) YOU OPT-OUT OF THESE
          ARBITRATION PROCEDURES WITHIN 30 DAYS FROM THE DATE THAT YOU FIRST
          CONSENT TO THESE TERMS (the “Opt-Out Deadline”). You may opt-out of
          this Provision by emailing Us at{' '}
          <Link
            color="inherit"
            underline="always"
            href="mailto:support@saveyourcity.zendesk.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            support@saveyourcity.zendesk.com
          </Link>{' '}
          the following information: (1) Your name; (2) Your address; (3) A
          clear statement that You do not wish to resolve Disputes with Us
          through arbitration. Either way, We will not take any decision You
          make personally. In fact, We promise that Your decision to opt-out of
          this Arbitration Provision will have no adverse effect on Your
          relationship with Us. But, We do have to enforce the Opt-Out Deadline
          so keep in mind that{' '}
          <b>
            any opt-out request received after the Opt-Out Deadline will not be
            valid and You must pursue Your Dispute in arbitration or small
            claims court
          </b>
          .
          <br />
          <br />
          <u>Arbitration Procedures</u>
          <br />
          <br />
          If this Provision applies and the Dispute is not resolved as provided
          above (Pre-Arbitration Claim Resolution) either You or We may initiate
          arbitration proceedings. The American Arbitration Association (“AAA”),
          www.adr.org, or JAMS, www.jamsadr.com, will arbitrate all Disputes,
          and the arbitration will be conducted before a single arbitrator. The
          arbitration shall be commenced as an individual arbitration only, and
          shall in no event be commenced as a class arbitration or a
          consolidated or representative action or arbitration. All issues shall
          be for the arbitrator to decide, including the scope of this
          Provision.
          <br />
          <br />
          For arbitration before AAA, for Disputes of less than $75,000, the
          AAA’s Supplementary Procedures for Consumer-Related Disputes will
          apply; for Disputes involving $75,000 or more, the AAA’s Commercial
          Arbitration Rules will apply. In either instance, the AAA’s Optional
          Rules For Emergency Measures Of Protection shall apply. The AAA rules
          are available at www.adr.org or by calling 1-800-778-7879. For
          arbitration before JAMS, the JAMS Comprehensive Arbitration Rules &
          Procedures and the JAMS Recommended Arbitration Discovery Protocols
          For Domestic, Commercial Cases will apply. The JAMS rules are
          available at www.jamsadr.com or by calling 1-800-352-5267. This
          Provision governs in the event it conflicts with the applicable
          arbitration rules. Under no circumstances will class action or
          representative procedures or rules apply to the arbitration.
          <br />
          <br />
          Because this Website and these Terms concern interstate commerce, the
          Federal Arbitration Act (“FAA”) governs the arbitrability of all
          Disputes. However, the arbitrator will apply applicable substantive
          law consistent with the FAA and the applicable statute of limitations
          or condition precedent to suit.
          <br />
          <br />
          <i>Arbitration Award</i> – The arbitrator may award on an individual
          basis any relief that would be available pursuant to applicable law,
          and will not have the power to award relief to, against or for the
          benefit of any person who is not a party to the proceeding. The
          arbitrator will make any award in writing but need not provide a
          statement of reasons unless requested by a party or if required by
          applicable law. Such award will be final and binding on the parties,
          except for any right of appeal provided by the FAA or other applicable
          law, and may be entered in any court having jurisdiction over the
          parties for purposes of enforcement.
          <br />
          <br />
          <i>Location of Arbitration</i> – You or We may initiate arbitration in
          either New York or the federal judicial district that includes Your
          billing address.
          <br />
          <br />
          <i>Payment of Arbitration Fees and Costs</i> – So long as You place a
          request in writing prior to commencement of the arbitration, We will
          pay all arbitration filing fees and AAA or JAMS hearing fees and any
          arbitrator's hearing fees, costs and expenses upon Your written
          request to the arbitrator given at or before the first evidentiary
          hearing in the arbitration. But, You will still be responsible for all
          additional fees and costs that You incur in the arbitration which
          include but are not limited to attorneys’ fees or expert witnesses. In
          addition to any fees and costs recoverable under applicable law, if
          You provide notice and negotiate in good faith with Us as provided in
          the section above titled “Pre-Arbitration Claim Resolution” and the
          arbitrator concludes that You are the prevailing party in the
          arbitration, You will be entitled to recover reasonable attorney’s
          fees and costs as determined by the arbitrator.
          <br />
          <br />
          <u>Class Action Waiver</u>
          <br />
          <br />
          Except as otherwise provided in this Provision, the arbitrator may not
          consolidate more than one person’s claims, and may not otherwise
          preside over any form of a class or representative proceeding or
          claims (such as a class action, consolidated action, representative
          action, or private attorney general action) unless both You and We
          specifically agree to do so in writing following initiation of the
          arbitration.{' '}
          <b>
            If You choose to pursue Your Dispute in court by opting out of the
            Arbitration Provision, as specified above, this Class Action Waiver
            will not apply to You.
          </b>{' '}
          Neither You, nor any other user of this Website can be a class
          representative, class member, or otherwise participate in a class,
          consolidated, or representative proceeding without having complied
          with the opt-out requirements above.
          <br />
          <br />
          <u>No Judge or Jury in Arbitration</u>
          <br />
          <br />
          Arbitration does not involve a judge or jury. You understand and agree
          that by entering into these Terms, Everyone is giving up the right to
          a jury trial or a trial before a judge in a public court. In the
          absence of this Provision, You and We might otherwise have had a right
          or opportunity to bring Disputes in a court, before a judge or jury,
          and/or to participate or be represented in a case filed in court by
          others (including class actions). Except as otherwise provided below,
          those rights are waived. Other rights that You would have if You went
          to court (e.g., the rights to both appeal and certain types of
          discovery) may be more limited or may also be waived.
          <br />
          <br />
          <u>Severability</u>
          <br />
          <br />
          If any clause within this Provision (other than the Class Action
          Waiver clause above) is found to be illegal or unenforceable, that
          clause will be severed from this Provision whose remainder will be
          given full force and effect. If the Class Action Waiver clause is
          found to be illegal or unenforceable, this entire Provision will be
          unenforceable and the Dispute will be decided by a court.
          <br />
          <br />
          <u>Continuation</u>
          <br />
          <br />
          This Provision shall survive Your discontinued use of this Website or
          the Services. Notwithstanding any provision in these Terms to the
          contrary, We agree that if We make any change to this Provision (other
          than a change to the Notice Address), You may reject any such change
          and require Us to adhere to the present language in this Provision if
          a Dispute between You and Us arises.
          <br />
          <br />
          <b>LANGUAGE.</b>
          <br />
          <br />
          The parties hereto have expressly required that these Terms and all
          documents and notices relating thereto be drafted in the English
          language.
          <br />
          <br />
          <b>GENERAL.</b>
          <br />
          <br />
          We think direct communication resolves most issues – if We feel that
          You are not complying with these Terms, We will tell You. We will even
          provide You with recommended necessary corrective action(s) because We
          value this relationship.
          <br />
          <br />
          However, certain violations of these Terms, as determined by Us, may
          require immediate termination of Your access to this Website without
          prior notice to You. The Federal Arbitration Act, New York state law
          and applicable U.S. federal law, without regard to the choice or
          conflicts of law provisions, will govern these Terms. Foreign laws do
          not apply. Except for Disputes subject to arbitration as described
          above, any disputes relating to these Terms or this Website will be
          heard in the courts located in New York County, New York. If any of
          these Terms are deemed inconsistent with applicable law, then such
          term(s) shall be interpreted to reflect the intentions of the parties,
          and no other terms will be modified. By choosing not to enforce any of
          these Terms, We are not waiving Our rights. These Terms are the entire
          agreement between You and Us and, therefore, supersede all prior or
          contemporaneous negotiations, discussions or agreements between
          Everyone about this Website. The proprietary rights, disclaimer of
          warranties, representations made by You, indemnities, limitations of
          liability and general provisions shall survive any termination of
          these Terms.
          <br />
          <br />
          <b>CONTACT US.</b>
          <br />
          <br />
          If You have any questions about these Terms or otherwise need to
          contact Us for any reason, You can reach Us at{' '}
          <Link
            color="inherit"
            underline="always"
            href="mailto:support@saveyourcity.zendesk.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            support@saveyourcity.zendesk.com
          </Link>
          .
        </Typography>
      </Grid>
    </Grid>
  );
};

async function getProps() {
  return {
    props: {
      styles: {
        color: theme.palette.orange,
      },
    },
  };
}
export const getServerSideProps = withAuth(getProps);

export default Terms;
